"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const card_1 = require("../../molecules/card");
const card_row_divided_1 = require("../../atoms/card-row-divided");
const typography_1 = require("../../shared/typography");
const react_i18next_1 = require("react-i18next");
exports.default = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Card, { header: (0, jsx_runtime_1.jsx)(typography_1.H2, { children: t("memberDetailsTranslations.codes.columnTitle") }, void 0), children: [(0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: t("memberDetailsTranslations.codes.programCode"), right: props.code.label }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: t("memberDetailsTranslations.codes.trainingCode"), right: props.code.trainingCode }, void 0), (0, jsx_runtime_1.jsx)(card_row_divided_1.CardRowDivided, { left: t("memberDetailsTranslations.codes.individualTrainingCode"), right: props.code.isIndividualCode
                    ? t("memberDetailsTranslations.codes.yes")
                    : t("memberDetailsTranslations.codes.no") }, void 0)] }, void 0));
};
const Card = (0, styled_components_1.default)(card_1.Card) `
  * {
    align-self: flex-start;
  }

  & > div:last-of-type div + div {
    align-self: flex-end;
  }
`;
//# sourceMappingURL=Codes.js.map